import { render } from "./StatementRow.vue?vue&type=template&id=ae54f5f4"
import script from "./StatementRow.vue?vue&type=script&lang=js"
export * from "./StatementRow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__